import React from 'react';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Modal Title Component
 * @param children {React.ReactNode}
 * @param className {string}
 */
const ModalFooter = ({ children, className }) => {
    const { styled } = useTrilogyContext();
    return React.createElement("div", { className: hashClass(styled, clsx('modal-footer', className)) }, children);
};
export default ModalFooter;
//# sourceMappingURL=ModalFooter.js.map